"use client";
// @ts-strict-ignore

// import isPropValid from "@emotion/is-prop-valid";
import { useServerInsertedHTML } from "next/navigation";
import type { ReactNode } from "react";
import { Fragment, useState } from "react";
import { ServerStyleSheet, StyleSheetManager } from "styled-components";
import { GlobalStyle } from "themes/global";
import lightTheme from "themes/light";

export default function StyledComponentsRegistry({
  children
}: {
  children: ReactNode;
}) {
  const [styledComponentsSheet] = useState(() => new ServerStyleSheet());

  useServerInsertedHTML(() => {
    const styles = styledComponentsSheet.getStyleElement();
    styledComponentsSheet.instance.clearTag();
    return <Fragment>{styles}</Fragment>;
  });

  if (typeof window !== "undefined") return <Fragment>{children}</Fragment>;

  return (
    <StyleSheetManager
      sheet={styledComponentsSheet.instance}
      // Adding shouldForwardProp to maintain same behavior from styled-components v5
      // https://styled-components.com/docs/faqs#what-do-i-need-to-do-to-migrate-to-v6
      // shouldForwardProp={(propName, target) => {
      //   if (typeof target === "string") {
      //     // For HTML elements, forward the prop if it is a valid HTML attribute
      //     return isPropValid(propName);
      //   }
      //   // For other elements, forward all props
      //   return true;
      // }}
    >
      <Fragment>
        <GlobalStyle theme={lightTheme} />
        {children}
      </Fragment>
    </StyleSheetManager>
  );
}
